import type {
  FinanceiroObrasToolbarProps,
  FinanceiroObrasToolbarViewModel,
} from "./types-financeiro-obras-toolbar";

export function useFinanceiroObrasToolbar(
  props: FinanceiroObrasToolbarProps,
): FinanceiroObrasToolbarViewModel {
  const { isMobile, filters } = props;

  return {
    ...props,
    showQuickFilters: !isMobile,
    statusValue: filters.statusFinanceiro,
    tipoValue: filters.tipoObra,
  };
}
